import { cn } from '@/lib/utils';

export interface ScopeBandEdges {
    capTop: boolean;
    capBottom: boolean;
}

/**
 * One member's slice of the band that marks the instrument the tools panel is
 * pointing at. A group owns no DOM ancestor of its own, so the band is drawn
 * per member and made continuous by bleeding 10px — half the `space-y-5` gap —
 * above and below, except at the run's true ends, where it hugs the content and
 * rounds off. A flat, bleeding edge is the signal that the instrument carries on
 * past a page break.
 *
 * Absolutely positioned and behind the content: it adds no layout box, so the
 * hidden measurer's pagination is untouched, and it never tints the table or the
 * editor chrome, which both paint above it.
 */
export function ScopeBand({ capTop, capBottom }: ScopeBandEdges) {
    return (
        <div
            aria-hidden
            data-scope-band
            data-block-selection-ui
            className={cn(
                'pointer-events-none absolute -inset-x-3 -z-10 border-x border-info/30 bg-info-subtle/60',
                capTop ? 'top-0 rounded-t-lg border-t' : '-top-2.5',
                capBottom ? 'bottom-0 rounded-b-lg border-b' : '-bottom-2.5',
            )}
        />
    );
}
